<template>
  <div class="mainCon">
    <div class="contbanner standbymain">
      <div class="mainDivWidth flexDiv stanmain">
        <div class="stanLeft wow fadeInLeft animated">
          <div class="scene-Header">
            <div class="flexDiv">
              <div class="stancont">
                <p class="sceneTitle">立减活动</p> 
                <p class="backtxt">企业推荐选择</p>
              </div>
              <p class="explantxt">用户在支付过程中，符合优惠条件直接享受满减优惠</p>
              <div class="startban">
                  <p>推荐指数：</p>
                  <img src="static/img/activity/start.png" alt="">
                  <img src="static/img/activity/start.png" alt="">
                  <img src="static/img/activity/start.png" alt="">
                  <img src="static/img/activity/start.png" alt="">
                  <img src="static/img/activity/start.png" alt="">
                </div>
            </div>
            
          </div>
        </div>
        <div class="stanRight wow fadeInRight animated">
          <img src="static/img/activity/standby/bannerpic.png" alt="">
        </div>
      </div>
    </div>
    <div class="conticon">
      <div class="mainDivWidth flexDiv conmains" >
        <div class="ditchList wow zoomIn animated" v-for="conlis in conticonList"  @click="changeanchorId(conlis.id)">
          <img :src="conlis.pic" alt="">
          <p>{{conlis.title}}</p>
        </div>
      </div>
    </div>
    <section id="recommend">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">推荐理由</h3>
        <div class="recommend flexDiv">
          <div v-for="rec in recomList"  class="recomlist">
            <img :src="rec.icons" alt="">
            <div class="recomtxt">
              <p>{{rec.title}}</p>
              <span>{{rec.cont}}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="contbg" id="contbg">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">活动数据</h3>
        <div class="flexDiv actDatamain">
          <div class="activedata" v-for="actl in activedatas">
            <p>{{actl.nums}}</p>
            <span>{{actl.explain}}</span>
          </div>
        </div>
      </div>
    </section>
    <section id="flowPath">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">活动流程</h3>
        <div class="flexDiv flowpics">
          <img src="static/img/activity/standby/flowicon/flowicon1.png" alt="">
          <img src="static/img/activity/direction.png" alt="">
          <img src="static/img/activity/standby/flowicon/flowicon2.png" alt="">
          <img src="static/img/activity/direction.png" alt="">
          <img src="static/img/activity/standby/flowicon/flowicon3.png" alt="">
        </div>
      </div>
    </section>
    <section id="actCase">
      <div class="casebg">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">活动案例</h3>
          <div class="flexDiv casecont">
            <img class="wow rotateInDownRight animated" src="static/img/activity/standby/casepic/casi01.png" alt="">
            <img class="wow rotateInDownRight animated" src="static/img/activity/standby/casepic/casi02.jpg" alt="">
            <img class="wow rotateInDownRight animated" src="static/img/activity/standby/casepic/casi03.jpg" alt="">
          </div>
        </div>
      </div>
    </section>
   
    <section>
      <div class="mainDivWidth">
        <h3 class="sectionTitle">我们还可以做到</h3>
        <div class="flexDiv maskcont">
          <div class="maskban wow bounceIn animated" v-for="mas in maskList">
            <img :src="mas.pics" alt="">
            <p>{{mas.title}}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  name: 'actStandBy',
  data:function(){
    return {
      conticonList:[
        {
          id:"recommend",
          title:"推荐理由",
          pic:"static/img/activity/standby/icon-2/logo01.png"
        },
        {
          id:"contbg",
          title:"活动数据",
          pic:"static/img/activity/standby/icon-2/logo02.png"
        },
        {
          id:"flowPath",
          title:"活动流程",
          pic:"static/img/activity/standby/icon-2/logo03.png"
        },
        {
          id:"actCase",
          title:"活动案例",
          pic:"static/img/activity/standby/icon-2/logo04.png"
        },
      ],
      recomList: [
        {
          icons:"static/img/activity/standby/icon-1/actstan01.png",
          title:"企业推荐选择",
          cont:"累计200+企业推荐选择，超60%重复采用"
        },
        {
          icons:"static/img/activity/standby/icon-1/actstan02.png",
          title:"一分钟快速上线",
          cont:"产品后台成熟稳定，配置方便快捷，专业人员快速处理"
        },
        {
          icons:"static/img/activity/standby/icon-1/actstan03.png",
          title:"用户参与度高",
          cont:"操作流程简洁，优惠感知明显，用户留存率高"
        },
        {
          icons:"static/img/activity/standby/icon-1/actstan04.png",
          title:"流水增量大",
          cont:"月度流水增大50%+，提高平台利"
        },
        {
          icons:"static/img/activity/standby/icon-1/actstan05.png",
          title:"数据获取及时",
          cont:"活动数据实时监控，安全/兼容数据随时查看"
        }
      ],
      activedatas:[
        {
          nums:"200个+", 
          explain:"活动数量"
        },
        {
          nums:"440万人次+",
          explain:"参与人数"
        },
        {
          nums:"12000万元+", 
          explain:"优惠金额"
        },
        {
          nums:"54000万元+", 
          explain:"交易金额"
        }
      ],
      maskList:[
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic01.png",
          title:"随机立减",
        },
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic02.png",
          title:"白名单优惠(手机号/银行卡号)",
        }, 
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic03.png",
          title:"指定油站品牌优惠",
        },
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic04.png",
          title:"信用卡/借记卡优惠",
        },
        {
          pics:"static/img/activity/actAdminSend/maspic/maspic05.png",
          title:"手机号归属地优惠",
        }
      ]
    }
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: false
    });
    wow.init();
  },
  methods: {
    changeanchorId(id) {
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      this.backTop = true;
      return false; // 返回false可以避免在原链接后加上#
    },
  }
}
</script>
<style scoped lang="scss">
  @import "../../assets/css/activityClass/standby";
</style>



// WEBPACK FOOTER //
// src/pages/activityTypePage/activity1-standby.vue